import { DateTime } from 'luxon'
import { environment } from '@environments/environment'
import { Table } from './Table'

export interface FloorPlanDateRange {
    startDate: Date
    endDate: Date
}

export class FloorPlan {

    constructor(
        public id: string,
        public displayName: string,
        public dateRanges: FloorPlanDateRange[],
        public tableIds: string[],
        public dateCreated: Date,
        public dateUpdated: Date
    ) { }

    get isDefault(): boolean {
        return this.dateRanges.length === 0
    }

    containsDate(date: Date): boolean {
        const dateTime = DateTime.fromJSDate(date)
            .setZone(environment.assumedVenueTimeZone)
            .startOf('day')
        return this.dateRanges.some(range => {
            const rangeStart = DateTime.fromJSDate(range.startDate)
                .setZone(environment.assumedVenueTimeZone)
                .startOf('day')
            const rangeEnd = DateTime.fromJSDate(range.endDate)
                .setZone(environment.assumedVenueTimeZone)
                .endOf('day')
            return dateTime >= rangeStart && dateTime <= rangeEnd
        })
    }

    overlapsWith(other: FloorPlan): boolean {
        for (const thisRange of this.dateRanges) {
            for (const otherRange of other.dateRanges) {
                if (rangesOverlap(thisRange, otherRange)) {
                    return true
                }
            }
        }
        return false
    }

    addTables(tables: Table[]) {
        tables.forEach(table => {
            if (!this.tableIds.includes(table.id)) {
                this.tableIds.push(table.id)
            }
        })
    }
}

function rangesOverlap(a: FloorPlanDateRange, b: FloorPlanDateRange): boolean {
    const aStart = DateTime.fromJSDate(a.startDate)
        .setZone(environment.assumedVenueTimeZone)
        .startOf('day')
    const aEnd = DateTime.fromJSDate(a.endDate)
        .setZone(environment.assumedVenueTimeZone)
        .endOf('day')
    const bStart = DateTime.fromJSDate(b.startDate)
        .setZone(environment.assumedVenueTimeZone)
        .startOf('day')
    const bEnd = DateTime.fromJSDate(b.endDate)
        .setZone(environment.assumedVenueTimeZone)
        .endOf('day')
    return aStart <= bEnd && bStart <= aEnd
}
